import { Directive, ElementRef, EventEmitter, Output } from '@angular/core';
import { Subject, filter, fromEvent, interval, switchMap, take, takeUntil } from 'rxjs';

@Directive({
  selector: '[onOutsideClick]',
  standalone: true,
})
export class OnOutsideClickDirective {

  readonly #destroy = new Subject<void>()


  @Output('onOutsideClick')
  readonly outsideClick = new EventEmitter<void>();

  get #element() {
    return this._elementRef.nativeElement;
  }

  constructor(
    private readonly _elementRef: ElementRef<HTMLElement>
  ) {

  }

  ngAfterViewInit() {


    interval(500).pipe(
      take(1),
      switchMap(() => fromEvent(document, 'click')),
      filter((ev: MouseEvent) => !this._elementRef.nativeElement.contains(ev.target as any)),
      takeUntil(this.#destroy)
    )
      .subscribe(() => {
        this.outsideClick.emit();
      })
  }

  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }

}
